<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<style>
	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		font-size: 16px;
	}

	ul {
		list-style: none;
	}

	div,
	p,
	span {
		user-select: none;
	}
	
	input{
		outline: none;
		appearance: none;
	}
</style>

<script>
	export default {
		name: 'App',
		created:function(){
			if(localStorage.locationInfo){
				this.$store.commit('updateLocationInfo',JSON.parse(localStorage.locationInfo))
			}
			if(localStorage.selCineInfo){
				this.$store.commit('updateCineInfo',JSON.parse(localStorage.selCineInfo))
			}
			if(localStorage.userInfo){
				this.$store.commit('updateUserInfo',JSON.parse(localStorage.userInfo))
			}
			if(localStorage.orderId){
				this.$store.commit('updateOrderId',JSON.parse(localStorage.orderId))
			}
			if(localStorage.idCards){
				this.$store.commit('updateIdCards',JSON.parse(localStorage.idCards))
			}
		},
		mounted:function(){
			/*区分关闭和刷新，关闭退出登录 start*/
			window.onload = function(){
			  if(!sessionStorage.tempFlag){
			    delete localStorage.userInfo;
			    location.reload();   //不能省，强制跳到登陆页
			  }else{
			    delete sessionStorage.tempFlag;
			  }
			}
			window.onunload = function (){
			  sessionStorage.tempFlag = true;
			}
			window.onbeforeunload = function (){
			  sessionStorage.tempFlag = true;
			}
		}
	}
</script>
